export default function CTABanner() {
  return (
    <section className="relative py-32 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=professional%20food%20photography%20of%20chef%20preparing%20fresh%20gourmet%20meal%20in%20modern%20kitchen%2C%20hands%20cooking%20with%20fresh%20ingredients%2C%20culinary%20preparation%20scene%2C%20warm%20natural%20lighting%2C%20clean%20minimalist%20background%2C%20high%20quality%20restaurant%20kitchen%20atmosphere%2C%20vibrant%20fresh%20food&width=1920&height=800&seq=cta-banner-001&orientation=landscape"
          alt="Chef preparing meals"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/60 to-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-6 lg:px-8 text-center">
        <h2 className="text-5xl lg:text-7xl font-bold text-white mb-6 leading-tight">
          Start Eating Better Today
        </h2>
        <p className="text-xl lg:text-2xl text-white/90 mb-10">
          Fresh meals delivered to your door. No commitment required.
        </p>

        {/* CTA Button */}
        <button className="inline-flex items-center gap-4 px-10 py-5 bg-white text-primary-500 text-xl font-bold rounded-full hover:bg-gray-100 transition-all shadow-2xl hover:shadow-white/20 hover:scale-105 whitespace-nowrap cursor-pointer">
          <span>Get Started Now</span>
          <div className="w-10 h-10 bg-primary-500 rounded-full flex items-center justify-center">
            <i className="ri-arrow-right-line text-white text-xl"></i>
          </div>
        </button>

        {/* Trust Indicators */}
        <div className="flex flex-wrap items-center justify-center gap-8 mt-12">
          <div className="flex items-center gap-2 text-white/90">
            <i className="ri-checkbox-circle-fill text-primary-300 text-xl"></i>
            <span className="text-sm">Cancel Anytime</span>
          </div>
          <div className="flex items-center gap-2 text-white/90">
            <i className="ri-checkbox-circle-fill text-primary-300 text-xl"></i>
            <span className="text-sm">No Delivery Fees</span>
          </div>
          <div className="flex items-center gap-2 text-white/90">
            <i className="ri-checkbox-circle-fill text-primary-300 text-xl"></i>
            <span className="text-sm">Fresh Guarantee</span>
          </div>
        </div>
      </div>
    </section>
  );
}